// extracted by mini-css-extract-plugin
export default {"footer":"PM-z"};